var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramCertificateBirth64(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pictogram/Medium./CertificateBirth64*",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }), /*#__PURE__*/React.createElement("g", {
    id: "Birth-Certificate",
    transform: "translate(12.000000, 4.000000)",
    stroke: "#4F4D4C",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "paper",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 40,
    height: 56
  }), /*#__PURE__*/React.createElement("g", {
    id: "Badge",
    transform: "translate(12.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Sash",
    fill: "#FFFFFF",
    points: "2 8 14 8 14 24 8 20 2 24"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "device",
    fill: "#FFCC00",
    x: 0,
    y: 0,
    width: 16,
    height: 16,
    rx: 8
  })), /*#__PURE__*/React.createElement("g", {
    id: "Details",
    transform: "translate(8.000000, 41.000000)",
    strokeDasharray: 0.4,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,5 L24,5",
    id: "Stroke-11-Copy-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4,1 L20,1",
    id: "Top"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramCertificateBirth64);
export default __webpack_public_path__ + "static/media/pictogramCertificateBirth64.a1f3c0ab79abb7ba7a8c9f92041622dc.svg";
export { ForwardRef as ReactComponent };